<template>
  <div class="no-access-label">
    <common-label title="権限がありません"></common-label>
  </div>
</template>

<script>
import CommonLabel from "../molecules/CommonLabel.vue";
export default {
  components: {
    CommonLabel,
  },
};
</script>

<style lang="scss" scoped></style>
